import { Injectable } from '@angular/core';
import { BaseWrapperService } from '../../shared/base-service/base-wrapper.service';
import { WipDocumentModel } from '../models/wip-document.model';

@Injectable()
export class WipDocumentService extends BaseWrapperService {

    public wipDocumentModel: WipDocumentModel;
    public createdVehicle: boolean;

    createWipDocument = () => this.post('Foundation/WipDocument/Create', null);
}
